<template>
    <div class="pb-2">
        <div class="card-header d-flex justify-content-between align-items-center">
            <span class="card-header__title">{{ $t('AppVehicleInfoImplements.Implementos') }}</span>
            <app-button type="success" class="card-header__save" @handleClick="linkImplementButtonPressed">
                <i class="pi pi-save"/>
            </app-button>
        </div>
        <div class="card-body d-flex align-items-center justify-content-center">
            <MultiSelect v-model="implementsToLink" dataKey="id" :options="organizationImplements" filter
                         optionLabel="identification" style="width: 100%"/>
        </div>

        <Dialog :visible.sync="showLinkImplementDialog" modal :contentStyle="{width: '450px'}">
            <template #header>
                <div style="font-size: larger; font-weight: bold" class="pl-3">
                    <span>{{$t('AppVehicleInfoImplements.Vincular Implemento')}}?</span>
                </div>
            </template>
            <div class="pl-3"/>
            <template #footer>
                <Button :label="$t('AppVehicleInfoImplements.Cancelar')" @click="showLinkImplementDialog = false" class="p-button-secondary"/>
                <Button :label="$t('AppVehicleInfoImplements.Vincular')" @click="linkImplements" class="p-button-info"/>
            </template>
        </Dialog>
    </div>
</template>

<script>

import Dialog from "primevue/dialog";
import Button from "primevue/button";
import MultiSelect from "primevue/multiselect";
import AppButton from "@/components/common/AppButton.vue";

import dateHourFormat from "@/mixins/DateMixin";

export default {
    mixins: [dateHourFormat],
    data() {
        return {
            showLinkImplementDialog: false,
            implementsToLink: []
        }
    },
    props: {
        vehicle: {
            type: Object,
            required: true
        },
        vehicleImplements: {
            type: Array,
            required: true
        },
        organizationImplements: {
            type: Array,
            required: true
        },
    },
    methods: {
        linkImplementButtonPressed() {
            this.showLinkImplementDialog = true;
        },
        linkImplements() {
            this.showLinkImplementDialog = false;
            this.$emit('linkImplements', this.implementsToLink);
        }
    },
    watch: {
        vehicleImplements: {
            handler(newValue) {
                this.implementsToLink = newValue;
            },
            deep: true
        }
    },
    components: {MultiSelect, Button, Dialog, AppButton}
}
</script>

<style scoped>

.card-header {
    padding: 14px 18px;
    border-bottom: 1px solid #f0f2f3;
}

.card-header__title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #3a3a3a;
}

.card-header__save {
    border-radius: 8px;
    padding: 6px 12px;
}

.card-header__save .pi {
    font-size: 13px;
    padding-right: 0;
}

.card-body {
    padding: 16px 18px;
}

</style>
